import { get } from "../../../api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL;

const loadFolderSummaryBeta = (documentId, siteId) => get(`${url}/leasingfolders/${documentId}/${siteId}/beta/summary`);

const exp = {
  loadFolderSummaryBeta
};
export default exp;
